<template>
    <div class="queryNode">
        <el-row type="flex" class="row-bg" justify="center">
            <el-col :span="20">
                <el-collapse
                    v-model="activeNames"
                    @change="handleChange"
                    accordion
                >
                    <el-collapse-item
                        title="Q : 更改开单件数和保价，操作方法"
                        name="1"
                    >
                        <div>
                            A
                            ：您好，货物离开始发网点，不允许更改件数和保价。您可以联系始发网点中止运单，重新开单。但是已产生的费用您还是需要和网点进行结算。请您联系始发网点帮您进行更改操作；
                        </div>
                    </el-collapse-item>
                    <el-collapse-item title="Q : 上楼费收取规则" name="2">
                        <div>
                            A
                            ：您好，我司为单件实际重量不超过100kg或最长边不超过2米的货物提供上楼服务。对于40kg以下的货物免费上楼，无电梯的上楼费用是：0.3
                            * 单票结算重量 + 20 *
                            n（50KG＜单件实际重量≤100KG的件数，加收20元/件），有电梯为无电梯的六折。
                        </div>
                    </el-collapse-item>
                    <el-collapse-item
                        title="Q :货物到达之后可否在目的网点暂放"
                        name="3"
                    >
                        <div>
                            A
                            ：您好，货到达目的网点后，可免费存放3天（含到货当天），超过3天需收取5元/立方米/天的仓储费用，超出7天会强制原返。
                        </div>
                    </el-collapse-item>
                    <el-collapse-item
                        title="Q : 代收货款服务费收费标准"
                        name="4"
                    >
                        <div>
                            A
                            ：我司代收货款手续费根据转款时效分为3类：T+0（12:00前签收，当天16:00转款；12:00后签收，
                            次日11:00转款）；T+1（12:00前签收，次日11:00转款；12:00后签收，
                            次日16:00转款）；T+3（72小时）。根据转款时效不同，代收货款的费率也会不同，建议您联系始发网点咨询。
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    name: "queryNode",
    data() {
        return {
            activeNames: ["1"]
        };
    },
    created() {},
    methods: {
        handleChange(val) {
        }
    }
};
</script>

<style scoped lang="scss">
.queryNode {
    .el-row {
        margin-top: 40px;
        margin-bottom: 80px;
        .el-collapse-item__content {
            font-size: 14pox;
        }
    }
}
</style>
